<template>
  <div style="height: 100%;">
    <div class="table-bar" style="margin-bottom: 0" v-if="showOpt">
      <el-form
          :inline="true"
          :model="queryForm"
          @keyup.enter.native="getDataList()"
          ref="queryForm"
          class="query-form"
      >
        <el-form-item prop="sellerName" label="订单编号：">
          <el-input v-model="queryForm.orderCode" size="mini" clearable type="text" placeholder="请输入外销合同号"></el-input>
        </el-form-item>
        <el-form-item prop="storeName" label="仓库：" v-if="showStorageName">
          <el-input v-model="queryForm.storeName" size="mini" clearable type="text" placeholder="请输入仓库名称"></el-input>
        </el-form-item>
        <el-form-item prop="productCode" label="品番号：" v-if="productType==='产品'">
          <el-input v-model="queryForm.productCode" size="mini" clearable type="text" ></el-input>
        </el-form-item>
        <el-form-item prop="skuCode" label="SKU：" v-if="productType==='产品'">
          <el-input v-model="queryForm.skuCode" size="mini" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item prop="productName" label="品名：">
          <el-input v-model="queryForm.productName" size="mini" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item prop="color" label="颜色：">
          <el-input v-model="queryForm.color" size="mini" clearable type="text" ></el-input>
        </el-form-item>
        <el-form-item prop="size" label="规格：">
          <el-input v-model="queryForm.size" size="mini" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item prop="attr1" label="幅宽：" v-if="productType==='原料'">
          <el-input v-model="queryForm.attr1" size="mini" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item prop="attr2" label="克重：" v-if="productType==='原料'">
          <el-input v-model="queryForm.attr2" size="mini" clearable type="text" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reload" size="mini">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <SweetTable url="/erp/store/list" ref="table" :query-form="queryForm" :summaries-column="['count']">
      <el-table-column prop="orderCode" label="订单编号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="storageName" label="仓库名称" header-align="center" align="center" :formatter="$c.companyNameFormatter" min-width="160" v-if="showStorageName"></el-table-column>
      <el-table-column prop="product.code" label="品番号" header-align="center" align="center" v-if="productType==='产品'"></el-table-column>
      <el-table-column prop="product.skuCode" label="SKU" header-align="center" align="center" v-if="productType==='产品'"></el-table-column>
      <el-table-column prop="product.name" label="品名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="product.color" label="颜色" header-align="center" align="center" ></el-table-column>
      <el-table-column prop="product.size" label="规格" header-align="center" align="center"></el-table-column>
      <el-table-column prop="product.attr1" label="幅宽" header-align="center" align="center"  v-if="productType==='原料'"></el-table-column>
      <el-table-column prop="product.attr2" label="克重" header-align="center" align="center" v-if="productType==='原料'"></el-table-column>
      <el-table-column prop="product.nameZh" label="中文品名" header-align="center" align="center" v-if="productType==='产品'"></el-table-column>
      <el-table-column prop="count" label="库存数量" header-align="center" align="center" width="100" fixed="right"></el-table-column>
      <el-table-column  label="操作" width="90" fixed="right"  header-align="center" align="center">
        <template #default="{ row }">
          <el-button type="text">查看明细</el-button>
        </template>
      </el-table-column>
    </SweetTable>
  </div>
</template>
<script>

import SweetTable from '@/mixins/SweetTable'
export default {
  mixins: [SweetTable],
  components: {},
  props: {
    productType: '',
    showOpt: {
      type: Boolean,
      default: true
    },
    orderId: {
      type: String,
      default: ''
    },
    autoLoad: {
      type: Boolean,
      default: true
    },
    showStorageName: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      queryForm: {
        productType: '',
        orderCode: '',
        storeName: '',
        productCode:'',
        skuCode:'',
        productName:'',
        color:'',
        size:'',
        attr1:'',
        attr2:''
      },
    }
  },
  watch: {
    orderId: {
      handler: function (newVal) {
        if (!newVal) {
          return
        }
        this.queryForm.orderId = newVal
      },
      immediate: true
    },
    productType: {
      handler: function (newVal) {
        this.queryForm.productType = newVal
      },
      immediate: true
    }
  },
  computed: {
    optName () {
      if (this.productType == '产品') {
        return '成品'
      } else if (this.productType == '原料') {
        return '原料'
      }
    }
  },
  methods: {
  },
}
</script>

<style scoped></style>
